import React, { useEffect, useState } from 'react';
import { Typography, Container, FormControl, Button, InputLabel, Select, IconButton, MenuItem, Grid, Paper, CircularProgress, FormHelperText } from '@material-ui/core'
import { useForm, Controller } from "react-hook-form";
import DownloadIcon from '@material-ui/icons/SaveAlt';
import SearchIcon from '@material-ui/icons/Search';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, PayOffListActions, MerchantActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    bankAccount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const payOffListSelector = (state) => state.PayOffList;
const IdentitySelector = (state) => state.Identity;

// 精算一覧画面
const PayOffList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const payOffListActions = bindActionCreators(PayOffListActions, dispatch);
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(payOffListSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, errors, handleSubmit, watch } = useForm();
  
    const { classes } = props;

    // 検索範囲
    // 確定日
    const [fixedDay, setFixedDay] = React.useState(null);
    // 加盟店タイプ
    const [merchantType, setMerchantType] = React.useState(null);

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="Adjustment.MerchantName" />,
                field: 'merchant_name',
                filtering: false
            },
            {
                // 加盟店タイプ
                title: <FormattedMessage id="Adjustment.MerchantType" />,
                field: 'merchant_type',
                lookup: {
                    'acquirer': "代表",
                    'general': "一般",
                },
                filtering: false
            },
            {
                // 支払額
                title: <FormattedMessage id="Adjustment.AmountPaid" />,
                field: 'payment_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
            {
                // 請求額
                title: <FormattedMessage id="Adjustment.AmountBilled" />,
                field: 'billing_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
            {
                // 過去分
                title: <FormattedMessage id="Adjustment.Elapse" />,
                field: 'past_unprocessed_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false,
                render: rowData => {
                    if (rowData.past_unprocessed_amount != 0) {
                        // 金額のカンマ処理
                        var amount = Number(rowData.past_unprocessed_amount).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
                        return (
                            <div>
                                <Typography className={classes.amount} >{amount}</Typography>
                                <Button onClick={() => onElapseClick(rowData)} variant="contained" color="secondary" size="small">
                                    <FormattedMessage id="Button.UnprocessedElapse" />
                                </Button>
                            </div>
                        )
                    } else {
                        return (
                            <Typography className={classes.amount}>¥{rowData.past_unprocessed_amount}</Typography>
                        )
                    }
                }
            },
            {
                // 繰越分
                title: <FormattedMessage id="Adjustment.CarryOver" />,
                field: 'carry_forward_unprocessed_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false,
                render: rowData => {
                    if (rowData.carry_forward_unprocessed_amount != 0) {
                        // 金額のカンマ処理
                        var amount = Number(rowData.carry_forward_unprocessed_amount).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
                        return (
                            <div>
                                <Typography className={classes.amount}>{amount}</Typography>
                                <Button onClick={() => onCarryOverClick(rowData)} variant="contained" color="secondary" size="small">
                                    <FormattedMessage id="Button.UnprocessedCarryOver" />
                                </Button>
                            </div>
                        )
                    } else {
                        return (
                            <Typography className={classes.amount}>¥{rowData.carry_forward_unprocessed_amount}</Typography>
                        )
                    }
                }
            },
            {
                // 振込先（口座番号、口座名義、金融機関名、支店名）
                title: <FormattedMessage id="Adjustment.Payee" />,
                field: 'financialinstitution_name',
                filtering: false,
                render: rowData => {
                    return (
                        <div>
                            <Typography className={classes.bankAccount}>{rowData.account_no}　{rowData.account_holder}</Typography>
                            <Typography className={classes.bankAccount}>{rowData.financialinstitution_name}　{rowData.branch_name}</Typography>
                        </div>
                    )
                }
            },
        ]
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {
            // 一覧を初期化
            payOffListActions.initListInfo();
        }
    }, []);

    /**
     * 
     * 検索ボタン押下時の処理
     * 
     */
    const onSearchClick = () => {
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var fixedDt = yyyy + '/' + mm + '/' + fixedDay;

        // 精算一覧を取得
        payOffListActions.listPayOffLists(token, searchDate, fixedDt, merchantType)
            .then(data => {
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param dtl 選択された行のデータ
     */
    const onDetailClick = (dtl) => {
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var fixedDt = yyyy + '/' + mm + '/' + fixedDay;

        // 精算日別一覧を取得
        payOffListActions.listPayOffListsDaily(token, searchDate, fixedDt, dtl.merchant_type, dtl.merchant_id)
            .then(data => {
                // 対象の加盟店IDの加盟店情報を取得
                merchantActions.loadEditModel(token, dtl.merchant_id)
                    .then(merchantInfo => {
                        // 精算サイクル取得
                        props.onDetail(dtl, fixedDt, merchantInfo.payment_cycle);
                    })
                    .catch(e => {
                        notificationActions.showError(e.message);
                    });
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     * 
     * 一覧の未了過去ボタン押下時の処理
     * 
     * @param dtl 選択された行のデータ
     */
    const onElapseClick = (dtl) => {
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var fixedDt = yyyy + '/' + mm + '/' + fixedDay;

        // 精算未了（過去分）一覧を取得
        payOffListActions.listPayOffListsElapse(token, searchDate, fixedDt, dtl.merchant_type, dtl.merchant_id)
            .then(data => {
                props.onElapse(dtl, fixedDt);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 一覧の未了繰越ボタン押下時の処理
     *
     * @param dtl 選択された行のデータ
     */
    const onCarryOverClick = (dtl) => {
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var fixedDt = yyyy + '/' + mm + '/' + fixedDay;

        // 精算未了（繰越分）一覧を取得
        payOffListActions.listPayOffListsCarryOver(token, searchDate, fixedDt, dtl.merchant_type, dtl.merchant_id)
            .then(data => {
                props.onCarryOver(dtl, fixedDt);
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * CSVダウンロードボタン押下時の処理
     *
     */
    const onDownloadClick = () => {
        if (list == null || list.length == 0) {
            // メッセージ表示
            notificationActions.showInfo('データが存在しません。');
            return;
        }

        var nowdt = new Date();
        var timeStr = nowdt.getFullYear()
            + ('0' + (nowdt.getMonth() + 1)).slice(-2)
            + ('0' + nowdt.getDate()).slice(-2)
            + '_'
            + ('0' + nowdt.getHours()).slice(-2)
            + ('0' + nowdt.getMinutes()).slice(-2)
            + ('0' + nowdt.getSeconds()).slice(-2);
        const fileName = `精算一覧_${timeStr}.csv`;

        var headData = '加盟店,加盟店タイプ,支払額,請求額,処理未了額(過去分),処理未了額(繰越分),振込先\r\n'
        var csvData = list.map(x => {
            var down = [];
            // 加盟店
            down.push(x.merchant_name);
            // 加盟店タイプ
            var merchantType = '';
            switch (x.merchant_type) {
                case 'acquirer':
                    merchantType = '代表';
                    break;
                case 'general':
                    merchantType = '一般';
                    break;
            }
            down.push(merchantType);
            // 支払額
            down.push(x.payment_amount);
            // 請求額
            down.push(x.billing_amount);
            // 処理未了額(過去分)
            down.push(x.past_unprocessed_amount);
            // 処理未了額(過去分)
            down.push(x.carry_forward_unprocessed_amount);
            // 振込先
            down.push(x.account_no + " " + x.account_holder + " " + x.financialinstitution_name + " " + x.branch_name);
            return down.join(',');
        }).join('\r\n');
        let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        let blob = new Blob([bom, headData + csvData], { type: 'text/csv' });
        // 結果ダウンロード用URL作成
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        // アンカータグを作成
        let link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        document.body.appendChild(link);
        // クリックイベントを発生させる（ダウンロード）
        link.click();
        document.body.removeChild(link);
        // メッセージ表示
        notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);

        //var yyyy = searchDate.slice(0, 4);
        //var mm = searchDate.slice(-2);
        //var fixedDt = yyyy + '/' + mm + '/' + fixedDay;

        //// 外部連携CSVファイルを取得
        //payOffListActions.downloadExternalLinkedCsv(token, searchDate, fixedDt, merchantType)
        //    .then(csvData => {
        //        console.log('csvData.length:' + csvData.length);
        //        if (csvData.length > 0) {
        //            // ダウンロードデータあり

        //            // 現在日時
        //            var nowdt = new Date();
        //            var timeStr = nowdt.getFullYear()
        //                + ('0' + (nowdt.getMonth() + 1)).slice(-2)
        //                + ('0' + nowdt.getDate()).slice(-2)
        //                + '_'
        //                + ('0' + nowdt.getHours()).slice(-2)
        //                + ('0' + nowdt.getMinutes()).slice(-2)
        //                + ('0' + nowdt.getSeconds()).slice(-2);

        //            // ダウンロードファイル名生成
        //            const fileName = `精算一覧_${fixedDt}_${timeStr}.csv`;

        //            // CSVファイルデータ（base64エンコードされた文字列形式で渡される）
        //            var b64Data = csvData[0].external_linked_csv;
        //            // base64でエンコードされた文字列をバイナリデータの各バイトの文字を持つ新しい文字列にデコード
        //            const byteCharacters = atob(b64Data);
        //            // デコードした文字列をバイト値の配列に変換
        //            const byteNumbers = new Array(byteCharacters.length);
        //            for (let i = 0; i < byteCharacters.length; i++) {
        //                byteNumbers[i] = byteCharacters.charCodeAt(i);
        //            }
        //            const byteArray = new Uint8Array(byteNumbers);
        //            // UTF8ファイル指定
        //            let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        //            // Blobに変換
        //            const contentType = 'text/csv';
        //            const blob = new Blob([bom, byteArray], { type: contentType });

        //            // ダウンロード用URL作成
        //            let url = (window.URL || window.webkitURL).createObjectURL(blob);
        //            // アンカータグを作成
        //            let link = document.createElement('a');
        //            link.download = fileName;
        //            link.href = url;
        //            document.body.appendChild(link);
        //            // クリックイベントを発生させる（ダウンロード）
        //            link.click();
        //            document.body.removeChild(link);
        //            // メッセージ表示
        //            notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);
        //        }
        //        else {
        //            // メッセージ表示
        //            notificationActions.showInfo(`ダウンロード可能なデータが存在しませんでした。`);
        //        }
        //    })
        //    .catch(e => {
        //        notificationActions.showError(e.message);
        //    });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;

        if (name.startsWith('nengestu')) {
            setSearchDate(value);
        }
        if (name.startsWith('fixed_day')) {
            setFixedDay(value);
        }
        if (name.startsWith('merchant_type')) {
            setMerchantType(value);
        }

        return value;
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    // 当月含めて過去13ヵ月分を選択可能
    //var month = (new Date()).getMonth() + 1;
    var nengetsu = [];
    var defaultValue;
    var i;
    for (i = 0; i < 13; i++) {
        // nヶ月前
        var dt = new Date();
        // yyyy/mm/dd 日にちは必ず存在する15日に固定
        dt = new Date(dt.getFullYear(), dt.getMonth() - i, 15);
        let value = dt.getFullYear() + ("0" + (dt.getMonth() + 1)).slice(-2);
        let title = dt.getFullYear() + '年' + ("0" + (dt.getMonth() + 1)).slice(-2) + '月';
        var addData = { value: value, title: title };
        nengetsu.push(addData);
        if (i == 0) {
            defaultValue = value;
        }
    }
    // 当月を初期表示(yyyymm形式保持)
    const [searchDate, setSearchDate] = useState(defaultValue);

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} onSubmit={handleSubmit(onSearchClick)} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="Adjustment.ListOfPayments" /></Typography>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={handleSubmit(onSearchClick)}><FormattedMessage id="Button.Search" /></Button>
                                </div>
                            </div>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormControl required fullWidth variant="outlined">
                                    <InputLabel id="adjustment-label-date"><FormattedMessage id={"Adjustment.YearAndMonth"} /></InputLabel>
                                    <Controller
                                        name="nengestu"
                                        control={control}
                                        onChange={onChange}
                                        defaultValue={defaultValue}
                                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                        as={<Select
                                            labelId="adjustment-label-date"
                                            id="adjustment-date"
                                            name="nengetsu"
                                            label={<FormattedMessage id={"Adjustment.YearAndMonth"} />}>
                                            {nengetsu.map((date) => {
                                                return <MenuItem value={date.value}>{date.title}</MenuItem>
                                            })}
                                        </Select>} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth required variant="outlined" error={errors.fixed_day && true}>
                                    <InputLabel id="adjustment-label-fixed-day"><FormattedMessage id={"Adjustment.FixedDate"} /></InputLabel>
                                    <Controller
                                        name="fixed_day"
                                        control={control}
                                        onChange={onChange}
                                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                        defaultValue={fixedDay}
                                        as={<Select
                                            labelId="adjustment-label-fixed-day"
                                            id="adjustment-fixed-day"
                                            label={<FormattedMessage id={"Adjustment.FixedDate"} />}>
                                            <MenuItem value="04">4日</MenuItem>
                                            <MenuItem value="12">12日</MenuItem>
                                            <MenuItem value="19">19日</MenuItem>
                                            <MenuItem value="26">26日</MenuItem>
                                        </Select>} />
                                    <FormHelperText>{errors.fixed_day ? errors.fixed_day.message : ""}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="adjustment-label-merchant-type"><FormattedMessage id={"Adjustment.MerchantType"} /></InputLabel>
                                    <Controller
                                        name="merchant_type"
                                        control={control}
                                        onChange={onChange}
                                        as={<Select
                                            labelId="adjustment-label-merchant-type"
                                            id="adjustment-merchant-type"
                                            label={<FormattedMessage id={"Adjustment.MerchantType"} />}>
                                            <MenuItem key='' value=''>＜未選択＞</MenuItem>
                                            <MenuItem value="acquirer"><FormattedMessage id={"Terminal.Merchant.Type.Acquirer"} /></MenuItem>
                                            <MenuItem value="general"><FormattedMessage id={"Terminal.Merchant.Type.General"} /></MenuItem>
                                        </Select>} />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{<FormattedMessage id="Adjustment.ResultsTitle" />}</Typography>}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（CSVダウンロードボタン、詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            // システム管理者と代表加盟店のみ
                            // 2021.02.25 外部連携ファイルを出力 すべてのアカウントで表示
                            //if (userData.role == 1 || userData.role == 3) {
                                return (
                                    <Button onClick={() => onDownloadClick()} variant="contained" color="secondary" size="medium" startIcon={<DownloadIcon />} >
                                        <FormattedMessage id="Button.DownloadCSV" />
                                    </Button>
                                )
                            //}
                            //else {
                            //    return (
                            //        <div></div>
                            //    )
                            //}
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PayOffList);
